import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview';
import './assets/less/index.less';
import * as echarts from 'echarts';
import img from './lib/img'
import utils from "./lib/utils";
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
import request from "./utils/request";
import axios from 'axios'

Vue.prototype.$axios = axios
// 在main.js中应该已经有
import { Button, Card } from 'element-ui'
Vue.use(Button)
Vue.use(Card)
Vue.prototype.$echarts = function (el) {
    return echarts.init(el, null, {renderer: 'svg'})
}
Vue.prototype.$images = img
Vue.config.productionTip = false;
Vue.use(iView);
Vue.use(utils)
Vue.use(ElementUI,{size:' small'})
Vue.prototype.request = request

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


